import { useSelector } from 'react-redux'

import { isClinic } from '~/state/modules/user'

const Clinic = ({
  children
}: {
  children: JSX.Element
}): JSX.Element | null => {
  const clinic = useSelector(isClinic)

  return clinic ? children : null
}

export default Clinic
